



import $ from 'jquery';
import {WOW} from 'wowjs'
import './listeners';
import './animation/components/navbar';
import './animation/components/socialBtn';
import './animation/components/cursor';
import './animation/components/typedText';
// import './animation/components/particles';
import './animation/tabs';
import './animation/pages/homepage';
import './animation/components/projects-slider';
import './scriptThree';
import '../homepage/libs/sketch-circles';
import {nicescrol} from 'jquery.nicescroll';
$(".do-nicescrol").niceScroll();

// To scroll down to Innovation Div
$(".scrollDownMouse").click(function() {
    $('html, body').animate({
        scrollTop: $("#innovations").offset().top 
    }, 1000);
    // $('nav').addClass('bluredBackground')
});
$(".scrollToTop").click(function() {
    $('html, body').animate({
        scrollTop: $("body").offset().top 
    }, 1000);
    // $('nav').addClass('bluredBackground')
});


$(".call-to-action").click(function() {
    $('html, body').animate({
        scrollTop: $("#form-signal").offset().top - 300
    }, 1000);
    console.log('call to action clicked!');

    // $('nav').addClass('bluredBackground')
});
 $(window).scroll(function() {
    var scroll = $(window).scrollTop();
    if (scroll >= 50) {
        $('nav').addClass('bluredBackground')

    } else {
        $('nav').removeClass('bluredBackground')

    }
    if(scroll >= 500){
        $('#call-to-action-nav').removeClass('hidden')
        $('#change-theme').removeClass('pushToRight')
        $('#change-theme-2').removeClass('pushToRight-20')
      

    }else{
        $('#change-theme').addClass('pushToRight')
        $('#call-to-action-nav').addClass('hidden')
        $('#change-theme-2').addClass('pushToRight-20')
    }
});


$(document).ready( function() {
    $('.loadingScreen').hide();
    $('body').removeAttr('style');

  });
  var wow = new WOW(
    {
      boxClass:     'wow',      // animated element css class (default is wow)
      animateClass: 'animated', // animation css class (default is animated)
      offset:       0,          // distance to the element when triggering the animation (default is 0)
      mobile:       true,       // trigger animations on mobile devices (default is true)
      live:         true,       // act on asynchronously loaded content (default is true)
      callback:     function(box) {
        // the callback is fired every time an animation is started
        // the argument that is passed in is the DOM node being animated
      },
      scrollContainer: null // optional scroll container selector, otherwise use window
    }
  );
  wow.init();
